import MenuFamily from '../MenuFamily/MenuFamily'
import MenuLink from '../MenuLink/MenuLink'
import type { MenuEntryView } from '../types'

interface MenuEntryProps {
  entry: MenuEntryView
  expanded: boolean
  fill: boolean
}

const MenuEntry = ({ entry, expanded, fill }: MenuEntryProps) => {
  if (entry.kind === 'link') return <MenuLink link={entry} expanded={expanded} fill={fill} />

  return <MenuFamily family={entry} expanded={expanded} fill={fill} />
}

export default MenuEntry
